module.exports = __webpack_public_path__ + "media/images/favicon-67b3cdd948447611fc48fa182b794440.ico";